import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import Dialog from "../../components/Dialog";
import { useStudentList } from "../../api/studentApi";
import { type Student } from "../../types/user";
import { usePostInbox } from "../../api/noticeApi";
import "./staffInbox.scss";

const StaffInbox = () => {
  const [title, setTitle] = useState("");
  const [openSearchStudent, setOpenSearchStudent] = useState(false);
  const [students, setStudents] = useState([]);
  const [student, setStudent] = useState<Student>();
  const [filter, setFilter] = useState("");
  const [content, setContent] = useState("");
  const { mutateAsync: postInbox } = usePostInbox();
  const navigate = useNavigate();

  const { data, refetch } = useStudentList({
    filter: { user_code: filter },
  });
  useEffect(() => {
    if (data) {
      setStudents(data.students);
    }
  }, [data]);

  const send = async () => {
    if (!student) {
      alert("받는 사람을 선택하세요.");
      return;
    }
    if (!title) {
      alert("제목을 입력하세요.");
      return;
    }
    if (!content) {
      alert("내용을 입력하세요.");
      return;
    }

    await postInbox({
      to: student.id,
      title,
      content,
    });
    alert("성공적으로 전송되었습니다.");
    navigate("..");
  };

  return (
    <div className="narrowContent staff-inbox">
      <Link to=".." className="moveButton">
        뒤로가기
      </Link>
      <div className="binary-grid">
        <p>보내는 사람:</p>
        <p>한양대학교 스포츠 지도사 연수원</p>
        <p>받는 사람: </p>
        <input
          type="text"
          onClick={() => setOpenSearchStudent(true)}
          onChange={() => {
            return;
          }}
          value={student?.user_code}
        />
        <p>제목: </p>
        <input
          type="text"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
        />
      </div>
      <textarea
        placeholder="내용을 입력하세요."
        value={content}
        onChange={(e) => setContent(e.target.value)}
      />
      <button onClick={send}>전송</button>
      {openSearchStudent && (
        <Dialog
          title="학생 검색"
          close={() => setOpenSearchStudent(false)}
          buttons={["close"]}
        >
          <div className="student-search">
            <input
              type="text"
              onChange={(e) => setFilter(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  refetch();
                }
              }}
              value={filter}
            />
            <button onClick={() => refetch()}>검색</button>
          </div>
          <div className="student-list">
            {students?.map((student: Student) => (
              <div
                key={student.id}
                className="student-row"
                onClick={() => {
                  setStudent(student);
                  setOpenSearchStudent(false);
                  setFilter("");
                }}
              >
                <p>{student.user_code}</p>
                <p>{student.name}</p>
              </div>
            ))}
          </div>
        </Dialog>
      )}
    </div>
  );
};

export default StaffInbox;
